import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function Code({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
            <path
                fill={color}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.05 12.45 3.6 9l3.45-3.45L6 4.5 1.5 9 6 13.5l1.05-1.05Zm3.9 0L14.4 9l-3.45-3.45L12 4.5 16.5 9 12 13.5l-1.05-1.05Z"
            />
        </svg>
    );
}

export default Code;
